import { createApi } from '@reduxjs/toolkit/query/react';
import { GetOrganizerCampaignsResponse } from './models';
import { getQueryStringFromParams } from 'lib.shared/src/utils';
import { Filters } from './models';
import { API_EVENT_TAGS } from 'lib.store/src/tags';
import { baseQueryWithReauth } from '../../main/baseQueryWithReauth';

export const organizerCampaigns = createApi({
  reducerPath: API_EVENT_TAGS.ORGANIZER_CAMPAIGNS,
  baseQuery: baseQueryWithReauth,
  tagTypes: [API_EVENT_TAGS.ORGANIZER_CAMPAIGNS],
  endpoints: (build) => ({
    getOrganizerCampaignsByEvent: build.query<
      GetOrganizerCampaignsResponse,
      { eventId: string; filters: Filters }
    >({
      query: ({ eventId, filters }) => {
        const { page, statuses, search, partners, landings } = filters;

        const params = new URLSearchParams();

        const partnersQueryString = getQueryStringFromParams(partners, 'partners');
        const statusesQueryString = getQueryStringFromParams(statuses, 'statuses');
        const landingsQueryString = getQueryStringFromParams(landings, 'landings');

        if (search && search.length > 2) {
          params.append('filters[search]', `${search}`);
        }

        if (page) {
          params.append('page', `${page}`);
        }

        const filterQueryString = params.toString();

        const queryString = [
          partnersQueryString,
          statusesQueryString,
          landingsQueryString,
          filterQueryString,
        ]
          .filter(Boolean)
          .join('&');

        return {
          url: `organizer/events/${eventId}/campaigns${queryString.length ? `?${queryString}` : ''}`,
          headers: {
            Accept: 'application/json',
          },
        };
      },
      providesTags: [API_EVENT_TAGS.ORGANIZER_CAMPAIGNS],
    }),
  }),
});

export const { useGetOrganizerCampaignsByEventQuery } = organizerCampaigns;
